import React, { useEffect } from "react"
import { withRouter, useParams } from "react-router-dom"
import {
  useSelector,
  connect,
  //useDispatch
} from "react-redux"
import BootstrapTable from "react-bootstrap-table-next"
import { Row, Col, UncontrolledTooltip, Container, Table } from "reactstrap"
import * as serviceAction from "../../store/ZWNzZXJ2aWNl/actions"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"

const EcServiceDetails = (props) => {
  //const specificDispatch = useDispatch()
  const { dispatch } = props
  let { id } = useParams()
  useEffect(() => {
    dispatch(serviceAction.loadInstructions({ leadId: id }))
  }, [])

  const update = useSelector((state) => state.ecservice)
  console.log(update, "myUpdate")

  const { quotation_preview = [] } = update

  const serviceDataTable = !isEmpty(quotation_preview)
    ? quotation_preview.map((data, index) => {
        return {
          sNo: index + 1,
          leadEventId: data.leadEventId,
          eventNo: data.eventNo,
          isLink: data.isLink,
          branchId: data.branchId,
          eventType: data.eventType,
          eventTypeName: data.eventTypeName,
          event: data.event,
          eventName: data.eventName,
          eventDate: !isEmpty(data.eventDate)
            ? moment(data.eventDate).format("DD-MM-YYYY")
            : "",
          startTime: data.startTime,
          endTime: data.endTime,
          venueLocation: data.venueLocation,
          venueName: data.venueName,
          serviceId: data.serviceId,
          services: data.service,
          serviceName: data.serviceName,
          quantity: data.quantity,
          actualAmount: data.actualAmount,
          _id: data._id,
          leadQuotationEventId: data.leadQuotationEventId,
        }
      })
    : []

  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "eventNo",
      text: "Event No",
      // sort: true,
      // csvExport: false,
      style: {
        color: "#e40d8c",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "eventName",
      text: "Event Name",
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "startTime",
      text: "Start Time",
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "endTime",
      text: "End Time",
      // sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },

    {
      dataField: "venueLocation",
      text: "Venue Location",

      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "venueName",
      text: "Venue Name",
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th
                style={{
                  backgroundColor: "#e40d8c",
                  color: "#ffffff",
                  width: "140px",
                }}
              >
                S.No
              </th>
              <th
                style={{
                  backgroundColor: "#e40d8c",
                  color: "#ffffff",
                  width: "190px",
                }}
              >
                Service Name
              </th>
              <th
                style={{
                  backgroundColor: "#e40d8c",
                  color: "#ffffff",
                  width: "140px",
                }}
              >
                Quantity
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.services.length > 0 ? (
              row.services.map((data, index) => {
                return (
                  <tr key={data._id}>
                    <td>{index + 1}</td>
                    <td>{data.serviceName}</td>
                    <td>{data.quantity}</td>
                  </tr>
                )
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={3}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  return (
    <React.Fragment>
      <Container>
        <Row className="quote-head-content">
          <Col md="12" lg="12" sm="12">
            <p className="quote-head">
              Service
              <span className="quote-info">
                <i
                  style={{ color: "grey" }}
                  id="quoteInfo1"
                  aria-hidden="true"
                  className="fa fa-info-circle ms-1"
                ></i>
                <UncontrolledTooltip placement="right" target="quoteInfo1">
                  Service
                </UncontrolledTooltip>
              </span>
            </p>
          </Col>
        </Row>
        <Col sm="12" md="12" lg="12" className="mb-3">
          <Row>
            <Col md="12" lg="12" xl="12" sm="12" xs="12">
              <BootstrapTable
                {...props.baseProps}
                data={serviceDataTable}
                responsive
                bordered={true}
                striped={true}
                keyField="leadEventId"
                columns={columns}
                expandRow={expandRow}
              />
            </Col>
            {/* <Col sm="12" lg="12" md="12">
              <Table bordered striped responsive>
                <thead>
                  <tr style={{ fontSize: "10px" }}>
                    <th>S.No</th>
                    <th>Event No</th>
                    <th>Event Name</th>
                    <th>Event Date</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Venue Location</th>
                    <th>Venue Name</th>
                    <th>Service Name</th>
                    <th>Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  {serviceDataTable.length > 0 ? (
                    serviceDataTable.map((data, index) => {
                      return (
                        <>
                          <tr key={data._id}>
                            <td>{index + 1}</td>
                            <td>{data.eventNo}</td>
                            <td>{data.eventName}</td>
                            <td>{data.eventDate}</td>
                            <td>{data.startTime}</td>
                            <td>{data.endTime}</td>
                            <td>{data.venueLocation}</td>
                            <td>{data.venueName}</td>
                            <td>{data.serviceName}</td>
                            <td>{data.quantity}</td>
                          </tr>
                        </>
                      )
                    })
                  ) : (
                    <>
                      {" "}
                      <tr key={0}>
                        <td colSpan={15} className="text-align-center">
                          {"No Data Found"}
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </Table>
            </Col> */}
          </Row>
        </Col>
      </Container>
    </React.Fragment>
  )
}
EcServiceDetails.propTypes = {
  dispatch: PropTypes.func,
  baseProps: PropTypes.any,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EcServiceDetails)
)
